<!--
  CampoData — `el-date-picker` che si apre cliccando su TUTTO il campo.

  ⚠️ Difetto di Element Plus 2.2.17: cliccando sul testo del campo il
  calendario si apre solo se il focus non arriva da un altro elemento
  (`handleFocusInput` apre solo con `relatedTarget` nullo). Se prima si è
  toccato un altro campo o un pulsante, il clic sulla barra non fa nulla e
  resta solo l'icona, che passa da un altro gestore. Qui il calendario si apre
  al `mousedown` su tutto il campo, prima che Element Plus decida.

  Si usa come `el-date-picker`: stessi attributi ed eventi, passati così come
  sono (v-model compreso).

  Uso:  <CampoData v-model="data" type="date" format="DD/MM/YYYY" />
-->
<template>
  <div
    class="campo-data"
    @mousedown.capture="apri"
  >
    <el-date-picker
      ref="picker"
      v-bind="$attrs"
      :model-value="modelValue"
      @update:model-value="(v) => $emit('update:modelValue', v)"
    />
  </div>
</template>

<script>
const attivo = (v) => v === '' || v === true;

export default {
  name: 'CampoData',
  inheritAttrs: false,

  props: {
    modelValue: {
      type: [Date, String, Number, Array],
      default: null,
    },
  },

  emits: ['update:modelValue'],

  methods: {
    apri(evento) {
      if (attivo(this.$attrs.disabled) || attivo(this.$attrs.readonly)) return;
      // La crocetta di cancellazione svuota il campo: non deve anche aprirlo.
      if (evento.target?.closest?.('.clear-icon')) return;
      this.$refs.picker?.handleOpen();
    },
  },
};
</script>

<style scoped>
/* Il contenitore non cambia l'impaginazione: larghezza e classi le decide chi
   usa il campo, come con `el-date-picker`. Gli eventi arrivano lo stesso,
   perché si propagano lungo il DOM e non lungo i box. */
.campo-data { display: contents; }
</style>
